
export function getUserFileImage(userFileId: number) {
    return `/api/file/${userFileId}`;
}